import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfigModule } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { UrlModule } from '../../../../core/routing';
import { BadgeModule } from '../../../../shared/components/badge';
import { HeaderNavigationItemModule } from '../../components/header-navigation-item';
import { MenuAccountComponent } from './menu-account.component';

@NgModule({
  declarations: [MenuAccountComponent],
  imports: [
    NzIconModule,
    CommonModule,
    I18nModule,
    UrlModule,
    HeaderNavigationItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MenuAccountComponent: {
          component: MenuAccountComponent,
        },
      },
    }),
    BadgeModule,
  ],
  providers: [],
  exports: [MenuAccountComponent],
})
export class MenuAccountModule {}
